module.exports = __webpack_public_path__ + "static/media/NF.8b6629d9.svg";